import { render, staticRenderFns } from "./AnalysisRecos.vue?vue&type=template&id=3020b4b2&scoped=true&"
import script from "./AnalysisRecos.vue?vue&type=script&lang=js&"
export * from "./AnalysisRecos.vue?vue&type=script&lang=js&"
import style0 from "./AnalysisRecos.vue?vue&type=style&index=0&id=3020b4b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3020b4b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3020b4b2')) {
      api.createRecord('3020b4b2', component.options)
    } else {
      api.reload('3020b4b2', component.options)
    }
    module.hot.accept("./AnalysisRecos.vue?vue&type=template&id=3020b4b2&scoped=true&", function () {
      api.rerender('3020b4b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenders/review/AnalysisRecos.vue"
export default component.exports